import { SVGProps } from 'react';

const DarkThemeIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="DarkThemeIcon">
    <path
      d="M11.15 7.69a5.414 5.414 0 0 1-8.965 2.125A5.413 5.413 0 0 1 4.31.85a5.276 5.276 0 0 0 6.841 6.84Z"
      stroke="currentColor"
      fill="none"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>)
);

export default DarkThemeIcon;
